import { MIME_TYPE } from '../constants/constants';

const mimeTypeToFileExtension = {
  [MIME_TYPE.pdf]: '.pdf',
  [MIME_TYPE.zip]: '.zip',
  [MIME_TYPE.csv]: '.csv'
};

const showContent = (blob, mimeType, name) => {
  // IE doesn't allow using a blob object directly as link href
  // instead it is necessary to use msSaveOrOpenBlob
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob);
    return;
  }
  // For other browsers:
  // Create a link pointing to the ObjectURL containing the blob.
  const data = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = data;
  link.download = name.replace(/\./g, '') + mimeTypeToFileExtension[mimeType];
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(function () {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(data);
  }, 100);
};

const showPdf = (blob, name) => {
  // It is necessary to create a new blob object with mime-type explicitly set
  // otherwise only Chrome works like it should
  const pdfBlob = new Blob([blob], { type: MIME_TYPE.pdf });
  showContent(pdfBlob, pdfBlob.type, name);
};

const showZip = (blob, name) => {
  // It is necessary to create a new blob object with mime-type explicitly set
  // otherwise only Chrome works like it should
  const zipBlob = new Blob([blob], { type: MIME_TYPE.zip });
  showContent(zipBlob, zipBlob.type, name);
};

const showCSV = (blob, name) => {
  // It is necessary to create a new blob object with mime-type explicitly set
  // otherwise only Chrome works like it should
  const csvBlob = new Blob([blob], { type: MIME_TYPE.csv });
  showContent(csvBlob, csvBlob.type, name);
};

export { showPdf, showCSV, showZip };
